import { Sparkles, Lock, CreditCard, Mail, Check } from 'lucide-react';
import { Modal, Btn } from './UI';

// Short descriptions per feature (matches section labels from Sidebar/MobileBottomNav)
const FEATURE_DESCRIPTIONS = {
  'Checklists': 'Crea y gestiona checklists de revisión para tus vehículos, con trazabilidad por fecha y responsable.',
  'Calendario': 'Planifica servicios en una vista de calendario visual con arrastrar-y-soltar, filtros por recurso y detección de conflictos.',
  'Facturación': 'Emite facturas profesionales con numeración automática, envío por email y exportación a PDF.',
  'Profesionales': 'Gestión avanzada de documentación sanitaria: titulaciones, colegiación, vencimientos y verificación.',
  'Informes': 'Accede a métricas avanzadas, gráficos de servicios, ingresos, rendimiento del equipo y exportación CSV.',
};

const DEFAULT_DESCRIPTION = 'Esta funcionalidad forma parte del Plan Pro. Actualiza tu suscripción para desbloquear herramientas avanzadas que hacen crecer tu negocio.';

export default function UpgradeModal({ open, feature, onClose, onGoToPlans }) {
  const description = FEATURE_DESCRIPTIONS[feature] || DEFAULT_DESCRIPTION;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Desbloquea ${feature || 'esta función'} con Plan Pro`}
      subtitle="Funcionalidad premium disponible en planes superiores"
      icon={Sparkles}
      size="md"
      footer={
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <Btn variant="secondary" icon={Mail} onClick={() => {
            window.location.href = 'mailto:soporte@thmedcoverpro.com?subject=Consulta%20Plan%20Pro';
          }}>
            Contactar soporte
          </Btn>
          <Btn variant="primary" icon={CreditCard} onClick={() => {
            onClose?.();
            onGoToPlans?.();
          }}>
            Ver planes
          </Btn>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* Hero banner */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          padding: 14, borderRadius: 10,
          background: 'linear-gradient(135deg, color-mix(in srgb, var(--accent) 14%, transparent), color-mix(in srgb, var(--blue) 14%, transparent))',
          border: '1px solid color-mix(in srgb, var(--accent) 25%, transparent)',
        }}>
          <div style={{
            width: 42, height: 42, borderRadius: 10, flexShrink: 0,
            background: 'color-mix(in srgb, var(--accent) 20%, transparent)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Lock size={20} style={{ color: 'var(--accent)' }} />
          </div>
          <div style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.5 }}>
            {description}
          </div>
        </div>

        {/* Benefits list */}
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 8 }}>
            Qué incluye Plan Pro
          </div>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {[
              'Módulos premium desbloqueados',
              'Soporte prioritario por email',
              'Usuarios y recursos ilimitados',
              'Integraciones avanzadas (Stripe, email)',
            ].map((benefit) => (
              <li key={benefit} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text)' }}>
                <Check size={14} style={{ color: 'var(--green, #10B981)', flexShrink: 0 }} />
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        <div style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', padding: '6px 0' }}>
          Puedes cancelar en cualquier momento.
        </div>
      </div>
    </Modal>
  );
}
